export default __webpack_public_path__ + "static/media/img_8.ce5c4e8e.jpg";